export const CHANGE_TIMEZONE = 'CHANGE_TIMEZONE'
export const GET_TIMEZONE = 'GET_TIMEZONE'
